import { Icons } from '@shared/components/content/icons';
import Text from '@shared/components/content/text';

interface ProductsStatusBreakdownProps {
  calculating: number;
  draft: number;
  complete: number;
  editing?: number;
}

function ProductStatus({
  icon,
  label,
  value,
}: {
  icon: React.ReactNode;
  label: string;
  value: number;
}) {
  return (
    <div className="flex min-w-32 space-x-4">
      {icon}
      <div className="ml-2">
        <Text>{label}</Text>
        <Text className="mt-1 text-nowrap text-xl font-bold">{value}</Text>
      </div>
    </div>
  );
}

const ProductsStatusBreakdown: React.FC<ProductsStatusBreakdownProps> = ({
  calculating,
  draft,
  complete,
  editing,
}: ProductsStatusBreakdownProps) => {
  const productStatuses = [
    {
      icon: <Icons.edit size={20} />,
      label: 'Drafts',
      value: draft,
    },
    {
      icon: <Icons.refreshCcw size={20} />,
      label: 'Submitted',
      value: calculating,
    },
    {
      icon: <Icons.info size={20} />,
      label: 'Editing',
      value: editing,
    },
    {
      icon: <Icons.checkCircle size={20} />,
      label: 'Complete',
      value: complete,
    },
  ];

  return (
    <div className="hidden size-full flex-wrap items-center justify-between rounded-md bg-gray-00 p-6 sm:flex">
      {productStatuses.map((status, index) => (
        <ProductStatus
          key={index}
          icon={status.icon}
          label={status.label}
          value={status.value!}
        />
      ))}
    </div>
  );
};

export default ProductsStatusBreakdown;
